import { Switch } from "react-router-dom";
import { AuthedRoute } from "../../helpers/authed-route";
import { AuthAuditLogContainer } from "./auth-audit";
import { UsersContainer } from "../settings/users";
import { UsersNewPage } from "../settings/users-new";
import { MFAPageContainer } from "../settings/mfa";
import { GroupsPageContainer } from "../settings/groups";
import {
  NamedRoute,
  route,
} from "../../../application/domain/routing/named-route";
import { ChangePasswordPage } from "../login/change-password";
import { GroupUsersContainer } from "../settings/group-users";
import { NotifFromGrafferContainer } from "./notif-from-graffer";
import { NotifFromGrafferDetailContainer } from "./notif-from-graffer-detail";
import { MyAccountContainer } from "./myaccount";
import { ServiceDocsContainer } from "./docs";
import { toQueryString } from "../../../utils/url-utils";
import { UserDetailContainer } from "./user-detail";
import { ServiceHelpPage } from "./help";
import { OrgSamlSettingContainer } from "./org-saml-setting";
import { UserAuditLogContainer } from "./user-audit";
import { QualifiedInvoiceBusinessIssuersIndexPage } from "./qualified-invoice/business-issuers/index/index";
import { QualifiedInvoiceBusinessIssuersNewPage } from "./qualified-invoice/business-issuers/new";
import { QualifiedInvoiceBusinessIssuerEditPage } from "./qualified-invoice/business-issuers/edit";
import { ServiceAccountsListPage } from "./service-accounts/list";
import { ServiceAccountCreatePage } from "./service-accounts/create";
import { ServiceAccountDetailPage } from "./service-accounts/detail";
import { OrgSessionSettingContainer } from "./org-session-setting";
import { SmartApplyApiSpecPage } from "./smart-apply/external-api-spec/api-spec";
import { PaymentsRawdataPage } from "./payments-rawdata";

export const SettingR = {
  Users: route({
    path: "/settings/users",
    component: UsersContainer,
  }),
  UsersNew: route({
    path: "/settings/users/new",
    component: UsersNewPage,
  }),
  UserDetail: route({
    path: "/settings/users/:id",
    link: (args: { id: string }) => `/settings/users/${args.id}`,
    component: UserDetailContainer,
  }),
  MyAccount: route({
    path: "/settings/myaccount",
    component: MyAccountContainer,
  }),
  Mfa: route({
    path: "/settings/mfa",
    component: MFAPageContainer,
  }),
  Groups: route({
    path: "/settings/groups",
    component: GroupsPageContainer,
  }),
  GroupUsers: route({
    path: "/settings/groups/:id/users",
    link: (args: { id: string }) => `/settings/groups/${args.id}/users`,
    component: GroupUsersContainer,
  }),
  NotifFromGraffer: route({
    path: "/settings/notif-from-graffer",
    link: () => `/settings/notif-from-graffer`,
    component: NotifFromGrafferContainer,
  }),
  NotifFromGrafferDetail: route({
    path: "/settings/notif-from-graffer/:slug",
    link: (slug: string) => `/settings/notif-from-graffer/${slug}`,
    component: NotifFromGrafferDetailContainer,
  }),
  GrafferServiceHelp: route({
    path: "/settings/help",
    link: () => `/settings/help`,
    component: ServiceHelpPage,
  }),
  GrafferServiceDocument: route({
    path: "/settings/docs",
    link: () => `/settings/docs`,
    component: ServiceDocsContainer,
  }),
  Payments: route({
    path: "/settings/payments-rawdata",
    link: () => `/settings/payments-rawdata`,
    component: PaymentsRawdataPage,
  }),
  QualifiedInvoiceBusinessIssuersIndex: route({
    path: "/settings/qualified-invoice/business-issuers",
    link: () => `/settings/qualified-invoice/business-issuers`,
    component: QualifiedInvoiceBusinessIssuersIndexPage,
  }),
  QualifiedInvoiceBusinessIssuersNew: route({
    path: "/settings/qualified-invoice/business-issuers/new",
    link: () => `/settings/qualified-invoice/business-issuers/new`,
    component: QualifiedInvoiceBusinessIssuersNewPage,
  }),
  QualifiedInvoiceBusinessIssuerEdit: route({
    path: "/settings/qualified-invoice/business-issuers/:id/edit",
    link: (args: { id: string }) =>
      `/settings/qualified-invoice/business-issuers/${args.id}/edit`,
    component: QualifiedInvoiceBusinessIssuerEditPage,
  }),
  ChangePassword: route({
    path: "/change-password",
    component: () => <ChangePasswordPage />,
  }),
  AuthAudit: route({
    path: "/audit",
    link: (args: { page?: string; to?: string; from?: string }) =>
      `/audit${toQueryString(args)}`,
    component: AuthAuditLogContainer,
  }),
  UserAudit: route({
    path: "/user-audit",
    link: () => `/user-audit`,
    component: UserAuditLogContainer,
  }),
  OrgSamlSetting: route({
    path: "/settings/saml-settings",
    link: () => `/settings/saml-settings`,
    component: OrgSamlSettingContainer,
  }),
  OrgSessionSetting: route({
    path: "/settings/session-settings",
    link: () => `/settings/session-settings`,
    component: OrgSessionSettingContainer,
  }),
  ServiceAccounts: route({
    path: "/settings/service-accounts",
    component: ServiceAccountsListPage,
  }),
  ServiceAccountCreate: route({
    path: "/settings/service-accounts/create",
    component: ServiceAccountCreatePage,
  }),
  ServiceAccountDetail: route({
    path: "/settings/service-accounts/:id",
    link: (args: { id: string; isNewlyCreated?: boolean }) =>
      `/settings/service-accounts/${args.id}${args.isNewlyCreated ? "?isNewlyCreated=true" : ""}`,
    component: ServiceAccountDetailPage,
  }),
  SmartApplyExternalApiSpec: route({
    path: "/settings/smart-apply/external-api-spec",
    component: SmartApplyApiSpecPage,
  }),
};

export const SettingsRoutes = () => {
  return (
    <Switch>
      {Object.keys(SettingR).map((k: string) => {
        const r = (SettingR as { [key: string]: NamedRoute<any> })[k].forRouter;

        if (r.hidden) {
          return null;
        }

        return (
          <AuthedRoute
            exact
            path={r.path}
            component={r.component}
            key={`SettingsRoutes-${k}`}
          />
        );
      })}
    </Switch>
  );
};
